import * as React from 'react';
import { InfoAnnie } from '../InfoAnnie';

interface IPolicyAnnieBanner {
  pathName: string;
}

export const PolicyAnnieBanner = ({ pathName }: IPolicyAnnieBanner) => {
  let allowPolicyAnnie = false;

  const policyAnnieMessagePaths = [
    '/account/policies',
  ];

  policyAnnieMessagePaths.forEach((path) => {
    if (pathName.includes(path)) {
      allowPolicyAnnie = true;
    }
  });

  let text = 'View your documents, make changes and manage your policy here.'
  let title = '';

  if (pathName.includes('checklist')) {
    text = '';
    title = 'Get ready for your trip!'
  }

  if (!allowPolicyAnnie) {
    return null;
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <InfoAnnie text={text} title={title}/>
    </div>
  )
}
